import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Podplistic from './pages/Podplistic';
// import CaseStudy from './pages/CaseStudy';

const App = () => {
  return(
  <Router>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/case-study/podplistic" element={<Podplistic />}/>
        {/* <Route path="/case-study/:id" element={<CaseStudy />} /> */}
      </Routes>
    </Router>
  )
}

export default App;
